import React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";

import AddSessionForm from "layouts/programs/sessions-list/components/AddSessionForm";

const AddSessionPopup = ({ open, close }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      sx={{
        "& .MuiPaper-root": {
          width: 350,
          overflowX: "hidden",
        },
      }}
      onClose={() => {
        close(false);
      }}
    >
      <Box
        role="presentation"
        // onClick={() => { close(false) }}
      >
        <AddSessionForm showAsPopup={close} />
      </Box>
    </Drawer>
  );
};

export default AddSessionPopup;
